import { AutogenModelBatchControl, AutogenRowBatchControl } from "./autogen/AutogenModelBatchControl";

export class ModelBatchControl extends AutogenModelBatchControl<RowBatchControl> {
	constructor() {
		super(RowBatchControl);
	}
}

export class RowBatchControl extends AutogenRowBatchControl {
}